
/*
 *
 * Date: 2025
 * Description: Setting page
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box, Typography } from "@mui/material"
import { ReactElement, JSX, useEffect, useState, useContext } from "react"
import { NavigateFunction, useNavigate } from "react-router-dom"

//Interfaces
import { i_initial_props , i_alert, i_promise } from "../../interfaces/utility.interface"
import { i_settings_form } from "../../interfaces/display.interfaces"
import { i_settings } from "../../interfaces/items.interface"
import { i_alert_control } from "../../interfaces/utility.interface"
import { t_method } from "../../types/types"

//Constants
import { defaultSettings , default_alert } from "../../utils/constant"

//Context
import { MainContext } from "../../context/context"

//Components
import SettingForm from "../../components/form/setting.form"
import AlertTop from "../../components/utils/alert"

//Utilities
import { handleFetch } from "../../api/fetch"

const MainSettings = ( props : i_initial_props )  :  JSX.Element | ReactElement => {
    const { HandleLogout } = useContext(MainContext)
    const [ form , setForm ] = useState<i_settings>(defaultSettings)
    const [ errors , setErrors ] = useState<i_settings>(defaultSettings)
    const [ loading , setLoading ] = useState<boolean>(false)
    const [ alert , setAlert ] = useState<i_alert>(default_alert)

    const nav : NavigateFunction = useNavigate()
    useEffect(() => {
        const getSettings = async() => {
            setLoading(true)
            const res = await handleFetch('/settings' , 'GET' , true , null)
            if(res.type === 'Success'){
                setForm(res.data)
            }else{
                if(res.type === 'Unauthorized'){
                    HandleLogout(nav)
                }else{

                }
            }
            setLoading(false)
        }
        getSettings();
    },[])
    
    const handleCallback = async( type : 'update' | 'test') : Promise<void> => {
        setLoading(true)
        var method : t_method = type === 'update' ? 'PUT' : 'POST'
        var arg : string = type == 'test' ? '/mail' : ''
        const res : i_promise = await handleFetch('/settings' + arg , method , true , form)
        if(res.type === 'Success'){
            setErrors(defaultSettings)
            setAlert({open : true, message : res.message, severity: type === 'update'?'success' : 'info'})
        }else{
            if(res.type === 'Unauthorized'){
                HandleLogout(nav)
            } else{
                setErrors(res.data)
                setAlert({open : true, message : res.message, severity: 'error'})
            }
        }
        setLoading(false)
    }

    const settingFormProps : i_settings_form = {
        form : form,
        errors : errors,
        setErrors : setErrors,
        setForm : setForm,
        loading : loading,
        callback : handleCallback,
    }

    const alert_props : i_alert_control = {
        alert : alert,
        onClose : () => setAlert(default_alert),
        float : 'initial',
        top : 0
    }

    return (
        <Box>
            <Box sx={{height : '100%'}}>            
                <AlertTop {...alert_props}/>
                <Box sx={{ paddingTop : '0vh'}}>
                    <SettingForm {...settingFormProps}/>
                </Box>
            </Box>
        </Box>
    )
}


export default MainSettings